const ToggleAnime = require('../velocity/toggle-anime');
const AddTapEvent = require('../event/add-tap-event');

/**
 * Accodion
 * @class
 */
class Accodion {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      selectors: {
        btn: 'dt',
      },
      isOpenedClass: 'is-opened',
    }
  };

  /**
   * @instance
   * @param el {string|HTMLElement} element
   * @param opts {object} options
   */
  constructor(el, opts = {}) {
    const { selectors, isOpenedClass } = _.defaults(opts, Accodion.defOpts);

    this.el    = el;
    this.btnEl = this.el.getElementsByTagName(selectors.btn);

    this.isOpenedClass = isOpenedClass;
    this.isAnimate     = false;

    this.createAnime();

    _.forEach(this.btnEl, (_el) => {
      const tapEvent_ = new AddTapEvent(_el);
      tapEvent_.add();
      _el.addEventListener(tapEvent_.eventType, this.toggle.bind(this), false);
    });
  }

  /**
   * @instance
   * @private
   */
  createAnime() {
    this.toggleAnime = new ToggleAnime({
      anime: [ 'slideDown', 'slideUp' ],
      opts : {
        duration: 300,
        easing  : 'easeOutCubic',
        complete: () => {
          this.isAnimate = false;
        },
      },
    });
  }

  /**
   * @instance
   * @private
   */
  toggle(e) {
    e.preventDefault();
    if(this.isAnimate) return;
    this.isAnimate = true;

    const cntEl = e.target.nextElementSibling;

    if(cntEl.style.display === 'block') {
      this.toggleAnime.run(false, {
        $el: cntEl,
      });
      e.target.classList.remove(this.isOpenedClass);
    }
    else {
      this.toggleAnime.run(true, {
        $el: cntEl,
      });
      e.target.classList.add(this.isOpenedClass);
    }
  }

}

/**
 * class exports
 */
module.exports = Accodion;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/accodion.js
 **/